'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StorageProxy = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _fp = require('lodash/fp');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Class encapsulating an storage implementation of the Web Storage API.
 * @see https://html.spec.whatwg.org/multipage/webstorage.html#the-storage-interface
 */
var StorageProxy = exports.StorageProxy = function () {
    /**
     * Constructor.
     * @param internalStorage, a storage implementing the Web Storage API.
     */
    function StorageProxy(internalStorage) {
        (0, _classCallCheck3.default)(this, StorageProxy);

        if (internalStorage === undefined) {
            throw new Error('Undefined internal storage');
        }
        this.internalStorage = internalStorage;
    }

    (0, _createClass3.default)(StorageProxy, [{
        key: 'length',
        value: function length() {
            var length = this.internalStorage.length;
            return (0, _fp.isFunction)(length) ? length.call(this.internalStorage) : length;
        }
    }, {
        key: 'isBrowserBased',
        value: function isBrowserBased() {
            return this.internalStorage === localStorage;
        }
    }, {
        key: 'getEntry',
        value: function getEntry(key) {
            var item = this.internalStorage.getItem(key);
            if (item) {
                return JSON.parse(item);
            }
            return null;
        }
    }, {
        key: 'saveEntry',
        value: function saveEntry(key, value) {
            this.internalStorage.setItem(key, JSON.stringify(value));
        }
    }, {
        key: 'deleteEntry',
        value: function deleteEntry(key) {
            this.internalStorage.removeItem(key);
        }
    }, {
        key: 'clear',
        value: function clear() {
            this.internalStorage.clear();
        }
    }]);
    return StorageProxy;
}();
